import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
	ArrowRight,
	Shield,
	Cloud,
	Monitor,
	Phone,
	Server,
	Users,
	Award,
	Zap,
	HardDrive,
	Activity,
	Globe,
	Briefcase,
	Building2,
	Stethoscope,
	GraduationCap,
	ShoppingCart,
	Truck,
	Landmark,
	Wrench,
	UtensilsCrossed,
	Hotel,
	Leaf,
	Code,
} from 'lucide-react';
import axios from 'axios';
import HOME_BANNER from '../assets/images/home_banner.jpg';
import ADVIES_IMG from '../assets/images/Dgitaal_advies.jpg';
import AZURE_IMG from '../assets/images/Dgitaal_azure.png';
import HACKED_IMG from '../assets/images/Dgitaal_hacked.jpg';
import M365_IMG from '../assets/images/Microsoft_365_Dgitaal.jpg';
import VOIP_IMG from '../assets/images/Dgitaal_VOIP.jpg';
import HARDWARE_IMG from '../assets/images/Dgitaal_hardware.jpg';
import HOME_CTA_ROYALTY_FREE_IMG from '../assets/images/home_cta_royalty_free.jpg';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const services = [
	{
		icon: Cloud,
		title: 'Cloud & Azure',
		desc: 'Migreer naar de cloud met Microsoft Azure. Schaalbaar, veilig en kostenefficiënt.',
		link: '/cloud',
		image: AZURE_IMG,
	},
	{
		icon: Shield,
		title: 'Cybersecurity',
		desc: 'Bescherm uw bedrijf tegen cyberdreigingen met geavanceerde security oplossingen.',
		link: '/diensten/cybersecurity',
		image: HACKED_IMG,
	},
	{
		icon: Monitor,
		title: 'Microsoft 365',
		desc: 'Optimaliseer productiviteit met Microsoft 365 - implementatie, migratie en beheer.',
		link: '/diensten/microsoft365',
		image: M365_IMG,
	},
	{
		icon: Server,
		title: 'Managed Services',
		desc: 'Volledig IT-beheer zodat u zich kunt focussen op uw kernactiviteiten.',
		link: '/diensten/managed-services',
		image: ADVIES_IMG,
	},
	{
		icon: Phone,
		title: 'Zakelijke Telefonie',
		desc: 'Moderne zakelijke telefonie met Microsoft Teams en VoIP oplossingen.',
		link: '/diensten/telefonie',
		image: VOIP_IMG,
	},
	{
		icon: HardDrive,
		title: 'Backup & Recovery',
		desc: 'Bescherm uw kritieke data met betrouwbare en geautomatiseerde backup-oplossingen.',
		link: '/diensten/backups',
		image: HARDWARE_IMG,
	},
];

const features = [
	{
		icon: Users,
		title: 'Persoonlijke aanpak',
		desc: 'Wij geloven in persoonlijk contact en oplossingen die echt werken voor uw bedrijf.',
	},
	{
		icon: Award,
		title: 'Microsoft Partner',
		desc: 'Als gecertificeerde Microsoft Partner beschikken we over de nieuwste kennis.',
	},
	{
		icon: Zap,
		title: 'Snelle doorlooptijd',
		desc: 'Wij werken efficient en zorgen voor een korte implementatietijd zonder compromissen.',
	},
];

const industries = [
	{ icon: Building2,       label: 'KMO & Corporate' },
	{ icon: Stethoscope,     label: 'Gezondheidszorg' },
	{ icon: Landmark,        label: 'Financiën' },
	{ icon: GraduationCap,   label: 'Onderwijs' },
	{ icon: ShoppingCart,    label: 'Retail & E-commerce' },
	{ icon: Truck,           label: 'Logistiek' },
	{ icon: Briefcase,       label: 'Juridisch & Notariaat' },
	{ icon: Wrench,          label: 'Techniek & Industrie' },
	{ icon: UtensilsCrossed, label: 'Horeca' },
	{ icon: Hotel,           label: 'Vastgoed' },
	{ icon: Leaf,            label: 'Non-profit' },
	{ icon: Globe,           label: 'Internationaal' },
];

const whyItems = [
	'Persoonlijke aanpak voor elk project',
	'Gecertificeerde Microsoft Partner',
	'Proactieve monitoring en ondersteuning',
	'Transparante prijzen zonder verrassingen',
	'Snelle responstijd bij problemen',
	'Lokaal bedrijf - Gent & omgeving',
];

export default function Home() {
	const [referenties, setReferenties] = useState([]);

	useEffect(() => {
		axios
			.get(`${API}/referenties`)
			.then((r) => setReferenties(r.data.slice(0, 3)))
			.catch(() => {});
	}, []);

	return (
		<div data-testid="home-page">
			<section
				className="relative min-h-screen flex items-center pt-20 overflow-hidden"
				style={{
					backgroundImage: `url(${HOME_BANNER})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
				data-testid="hero-section"
			>
				<div className="absolute inset-0" style={{
					background: 'linear-gradient(135deg, rgba(22,34,75,0.7) 0%, rgba(35,58,128,0.6) 50%, rgba(22,34,75,0.75) 100%)'
				}} />
				<div className="absolute inset-0 dot-pattern" />

				<div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 w-full">
					<div className="max-w-2xl">
						<h1
							className="text-white font-bold tracking-tight mb-6 animate-fade-in stagger-1"
							style={{
								fontSize: 'clamp(2.5rem, 5vw, 4rem)',
								lineHeight: 1.1,
								letterSpacing: '-0.03em',
							}}
						>
							Verbind <span className="text-[#f5c518]">Optimaal</span>
							
						</h1>

						<p className="text-white/70 text-lg leading-8 mb-10 animate-fade-in stagger-2 max-w-xl">
							Uw betrouwbare partner voor IT-oplossingen. Van cloud infrastructuur tot maatwerk
							software - wij brengen uw digitale transformatie tot leven.
						</p>

						<div className="flex flex-wrap gap-4 animate-fade-in stagger-3">
							<Link to="/contact" className="btn-gradient">
								Start een project <ArrowRight className="w-4 h-4" />
							</Link>
							<Link to="/diensten" className="btn-outline-white">
								Bekijk diensten
							</Link>
						</div>
					</div>
				</div>

				<div className="hero-wave">
					<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 180 2500 200" fill="#ffffff" width="100%">
						<path d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250">
							<animate
								attributeName="d"
								dur="5s"
								values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
												M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
												M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250"
								repeatCount="indefinite"
							/>
						</path>
					</svg>
				</div>
			</section>

			<section className="py-16 bg-white" data-testid="features-section">
				<div className="max-w-[1400px] mx-auto px-6 lg:px-10">
					<div className="grid grid-cols-1 md:grid-cols-3 gap-10">
						{features.map((f, i) => (
							<div key={i} className="feature-box">
								<div className="feature-box-icon">
									<f.icon className="w-6 h-6" />
								</div>
								<div>
									<h4 className="text-[#16224b] text-lg font-bold mb-1">{f.title}</h4>
									<p className="text-[#6b7184] text-sm leading-7">{f.desc}</p>
								</div>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="py-24 bg-[#f8f9fd]" data-testid="why-section">
				<div className="max-w-[1400px] mx-auto px-6 lg:px-10">
					<div className="grid lg:grid-cols-2 gap-16 items-center">
						<div className="relative">
							<div className="relative overflow-hidden rounded-lg shadow-2xl">
								<img src={ADVIES_IMG} alt="Dgitaal advies" className="w-full object-cover" style={{ height: '480px' }} />
							</div>
							<div className="absolute -bottom-6 -right-4 md:right-0 bg-[#16224b] text-white px-7 py-5 rounded-lg shadow-xl">
								<p className="text-3xl font-bold text-gradient">10+</p>
								<p className="text-white/70 text-sm mt-1">Jaar ervaring</p>
							</div>
						</div>

						<div>
							<h2 className="text-[#16224b] mb-5" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)' }}>
								Krachtig IT-bureau voor
								<br />
								Belgische bedrijven.
							</h2>
							<p className="text-[#6b7184] text-base leading-8 mb-8">
								Als jong en dynamisch IT-bedrijf combineren we frisse ideeen met bewezen
								technologieen. We geloven in persoonlijk contact en oplossingen die echt werken voor
								uw bedrijf.
							</p>

							<div className="space-y-5 mb-10">
								<div>
									<div className="flex justify-between text-sm font-semibold text-[#16224b] mb-2">
										<span>Klanttevredenheid</span>
										<span className="text-[#3d56a6]">98%</span>
									</div>
									<div className="progress-bar-track">
										<div className="progress-bar-fill" style={{ width: '98%' }} />
									</div>
								</div>
								<div>
									<div className="flex justify-between text-sm font-semibold text-[#16224b] mb-2">
										<span>Projectsucces</span>
										<span className="text-[#f2a100]">95%</span>
									</div>
									<div className="progress-bar-track">
										<div
											className="progress-bar-fill"
											style={{ width: '95%', background: 'linear-gradient(90deg, #3d56a6, #f2a100)' }}
										/>
									</div>
								</div>
							</div>

							<ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
								{whyItems.map((item, i) => (
									<li key={i} className="feature-check text-sm text-[#16224b]">
										{item}
									</li>
								))}
							</ul>

							<Link to="/contact" className="btn-gradient">
								Maak kennis <ArrowRight className="w-4 h-4" />
							</Link>
						</div>
					</div>
				</div>
			</section>

			<section className="py-24 bg-white" data-testid="services-section">
				<div className="max-w-[1400px] mx-auto px-6 lg:px-10">
					<div className="flex flex-col md:flex-row md:items-end justify-between mb-14 gap-6">
						<div>
							<h2 className="text-[#16224b]" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.5rem)' }}>
								Complete IT-oplossingen
								<br />
								voor uw bedrijf.
							</h2>
						</div>
						<Link to="/diensten" className="btn-outline-dark shrink-0">
							Alle diensten <ArrowRight className="w-4 h-4" />
						</Link>
					</div>

					<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7" data-testid="services-grid">
						{services.map((s, i) => (
							<Link key={i} to={s.link} className="service-card group" data-testid={`service-card-${i}`}>
								<div className="service-card-img">
									<img
										src={s.image}
										alt={s.title}
										className="w-full h-[180px] object-cover"
									/>
								</div>
								<div className="service-card-body">
									<h3 className="text-[#16224b] text-lg font-bold mb-2">{s.title}</h3>
									<p className="text-[#6b7184] text-sm leading-7">{s.desc}</p>
								</div>
								<div className="service-card-footer">
									<span className="service-card-link">
										Meer informatie <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-1" />
									</span>
								</div>
							</Link>
						))}
					</div>
				</div>
			</section>

			<section className="section-dark py-24" data-testid="industries-section">
				<div className="max-w-[1400px] mx-auto px-6 lg:px-10">
					<div className="text-center mb-14">
						<h2 className="text-white" style={{ fontSize: 'clamp(1.5rem, 2.5vw, 2rem)' }}>
							Wij werken voor diverse sectoren.
						</h2>
					</div>
					<div className="grid grid-cols-3 sm:grid-cols-4 lg:grid-cols-6 gap-0">
						{industries.map((ind, i) => (
							<div key={i} className="industry-box" data-testid={`industry-${i}`}>
								<ind.icon className="w-9 h-9 text-white mb-3" />
								<span className="text-white text-xs font-bold uppercase tracking-widest">{ind.label}</span>
							</div>
						))}
					</div>
				</div>
			</section>

			<section className="bg-[#233a80] py-8" data-testid="cta-banner">
				<div className="max-w-[1400px] mx-auto px-6 lg:px-10">
					<div className="flex flex-col md:flex-row items-center justify-between gap-4">
						<p className="text-white text-lg font-medium">
							Bespaar tijd en moeite bij het zoeken naar een oplossing.{' '}
							<a href="mailto:hello@dgitaal.be" className="underline hover:text-[#f8d45a] transition-colors">
								Neem nu contact op
							</a>
						</p>
						<Link to="/contact" className="btn-gradient shrink-0">
							Start een project <ArrowRight className="w-4 h-4" />
						</Link>
					</div>
				</div>
			</section>

			{referenties.length > 0 && (
				<section className="py-24 bg-[#f8f9fd]" data-testid="testimonials-section">
					<div className="max-w-[1400px] mx-auto px-6 lg:px-10">
						<div className="text-center mb-14">
							<h2 className="text-[#16224b]" style={{ fontSize: 'clamp(1.75rem, 3vw, 2.25rem)' }}>
								Vertrouwd door groeiende bedrijven.
							</h2>
						</div>

						<div
							className={`grid gap-7 ${
								referenties.length === 1
									? 'max-w-xl mx-auto'
									: referenties.length === 2
										? 'md:grid-cols-2 max-w-3xl mx-auto'
										: 'md:grid-cols-3'
							}`}
						>
							{referenties.map((ref, i) => (
								<div key={ref.id} className="quote-card" data-testid={`testimonial-${i}`}>
									<p className="text-[#6b7184] leading-8 text-sm italic mb-6 mt-4">&ldquo;{ref.quote}&rdquo;</p>
									<div className="flex items-center gap-4 border-t border-gray-100 pt-5">
										<div
											className="w-11 h-11 rounded-full flex items-center justify-center font-bold text-white text-lg flex-shrink-0"
											style={{ background: 'linear-gradient(135deg, #3d56a6, #f2a100)' }}
										>
											{ref.contactpersoon?.charAt(0)}
										</div>
										<div>
											<p className="font-bold text-[#16224b] text-sm">{ref.contactpersoon}</p>
											<p className="text-[#6b7184] text-xs">
												{ref.functie} - {ref.bedrijf}
											</p>
										</div>
									</div>
								</div>
							))}
						</div>
					</div>
				</section>
			)}

			<section
				className="relative overflow-hidden py-32 flex items-center"
				style={{
					backgroundImage: `url(${HOME_CTA_ROYALTY_FREE_IMG})`,
					backgroundSize: 'cover',
					backgroundPosition: 'center',
				}}
				data-testid="cta-section"
			>
				<div className="absolute inset-0 bg-[#16224b]/88" />
				<div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-10 text-center w-full">
					<h2
						className="text-white font-bold mb-8 max-w-3xl mx-auto"
						style={{ fontSize: 'clamp(2rem, 4vw, 3rem)', letterSpacing: '-0.02em' }}
					>
						Wij leveren creatieve IT-oplossingen voor uw bedrijf!
					</h2>
					<Link to="/contact" className="btn-gradient text-base px-10 py-4">
						Bespreek uw project <ArrowRight className="w-5 h-5" />
					</Link>
				</div>
			</section>
		</div>
	);
}
